import { firestore } from '@/firebaseConfig';
import Country from '../model/Country';

export default class PublisherService {
    loadCountries() {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("countries").get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new Country(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }
}